'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { find } from 'lodash';
import { doRedirect } from '../../data/service/coxapolku/actions';
import WindowUtils from '../../utils/WindowUtils';
import { withPageBase } from '../../components/PageBase';
import Alert from '../../components/Alert';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';
import { KAYTTAJA, PYYDETTY } from '../../definitions/PolkuConstants';

/*
 * Redirects user to an external URL, where user can download coxaPolku app.
 * See coxaPolku-service/src/main/resources/coxapolku/README.md.
 * */

const CoxaPolkuRedirect = (props) => {
  const { coxaPolku, doRedirect, integrations } = props;

  WindowUtils.clearSessionStorage();

  useEffect(() => {
    if (coxaPolku.url !== '' && coxaPolku.url !== null) {
      if (!coxaPolku.isFetching) {
        WindowUtils.navigate(coxaPolku.url);
      }
    }
  }, [coxaPolku.url]);

  const coxaPolkuObject = find(integrations.data, { name: 'CoxaPolku' });
  const hasValidCoxaPolku =
    coxaPolkuObject &&
    (coxaPolkuObject.status === PYYDETTY ||
      coxaPolkuObject.status === KAYTTAJA);

  useEffect(() => {
    if (hasValidCoxaPolku) {
      doRedirect();
    }
  }, [hasValidCoxaPolku]);

  if (integrations.isFetching || coxaPolku.isFetching) {
    return <Loader />;
  }

  if (!hasValidCoxaPolku) {
    return (
      <Alert message={`coxapolku.Redirect.js.error`}>
        {' '}
        <Link to={'/'} className={'alert-link'}>
          Palaa OmaTaysin etusivulle
        </Link>
      </Alert>
    );
  }

  if (coxaPolku.error !== null) {
    return <Alert message={`coxapolku.Redirect.js.urlerror`} />;
  }

  return (
    <>
      <FormattedMessage id={`coxapolku.Redirect.js.message`}>
        {(txt) => <p>{txt}</p>}
      </FormattedMessage>
      <a className={`tayspolku-link`} href={coxaPolku.url}>
        Sovellukseen
      </a>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    coxaPolku: state.services.coxaPolku,
    integrations: state.services.integrations,
  };
};

export default withPageBase(
  connect(mapStateToProps, { doRedirect })(CoxaPolkuRedirect),
  { title: '' }
);
